export default "__VITE_ASSET__DxXiXBfd__"